import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TonnageCalculator: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Tonnage Calculator
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography>Tonnage calculator content will be added here.</Typography>
      </Paper>
    </Box>
  );
};

export default TonnageCalculator;
